export default __webpack_public_path__ + "static/media/home-image-two.504edfe0.jpeg";